import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {DashboardSearchParams} from '../../types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useMemo} from 'react'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {formatNumber} from '@/utilities/helpers'

export const DashboardOpenProjectsCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({
        fields: ['projects'],
        ...searchParams
    })

    const totalProjects = useMemo(() => {
        return (data?.projects?.renewed ?? 0) + (data?.projects?.new ?? 0)
    }, [data?.projects])

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:open_projects')} />
    }

    return (
        <DashboardCard title={t('dashboard:open_projects')}>
            <Flexbox direction="column" gap={4}>
                <Grid columns={2} gap={2}>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {formatNumber(totalProjects)}
                    </Text>
                </Grid>

                <ul>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.projects?.renewed ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:renewed_projects')}
                            </Text>
                        </Flexbox>
                    </li>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.projects?.new ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:new_projects')}
                            </Text>
                        </Flexbox>
                    </li>
                </ul>
            </Flexbox>
        </DashboardCard>
    )
}
